import { render, staticRenderFns } from "./FundRequests.vue?vue&type=template&id=023c423d&scoped=true"
import script from "./FundRequests.vue?vue&type=script&lang=js"
export * from "./FundRequests.vue?vue&type=script&lang=js"
import style0 from "./FundRequests.vue?vue&type=style&index=0&id=023c423d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c423d",
  null
  
)

export default component.exports